module.exports = __webpack_public_path__ + "static/media/delete.e3497f38.svg";